module.exports = __webpack_public_path__ + "img/smart-home-angle-svgrepo-com.3db166c4.svg";